import * as React from 'react'
import cn from 'classnames'
import Image from 'next/image'

import playIcon from './play.svg'

import styles from './PlayButton.module.css'

type PlayButtonProps = {
  featuredVideo?: boolean
  onClick?: () => void
}

const PlayButton: React.FC<PlayButtonProps> = ({ featuredVideo, onClick }) => {
  return (
    <button
      className={cn(styles.profilePlayButton, {
        [styles.featuredPlayButton]: featuredVideo,
      })}
      type="button"
      onClick={onClick}
    >
      <Image src={playIcon} width={40} height={40} alt="Play" />
    </button>
  )
}

export default PlayButton
